<div class="top-bar">
  <div class="tabs">
    <div [class.active]="currentTab === 'EDITOR'" (click)="switchTab('EDITOR')" class="clickable tab" translate="CALLS.EDITOR"></div>
    @if (call.isOutlineReady) {
      <div [class.active]="currentTab === 'OUTLINE'" (click)="switchTab('OUTLINE')" class="clickable tab" translate="CALLS.OUTLINE"></div>
    }
  </div>
  @if (call.isPostProcessingComplete) {
    <div class="buttons">
      @if (currentTab === 'OUTLINE') {
        @if (showExpandAll) {
          <button mat-icon-button (click)="expandAll()">
            <mat-icon fontSet="material-symbols-outlined">expand_all</mat-icon>
          </button>
        } @else {
          <button mat-icon-button (click)="collapseAll()">
            <mat-icon fontSet="material-symbols-outlined">collapse_all</mat-icon>
          </button>
        }
      }
      @if (canUserEdit && currentTab === 'EDITOR') {
        <button mat-icon-button (click)="showRevisionHistory()" [matTooltip]="'CALLS.SHOW_REVISION_HISTORY' | translate" [disabled]="isEditorLockedByOtherUser">
          <mat-icon>timeline</mat-icon>
        </button>
        <button mat-icon-button (click)="resetEditor()" [matTooltip]="'CALLS.RESET_EDITOR' | translate" [disabled]="isEditorLockedByOtherUser">
          <mat-icon>history</mat-icon>
        </button>
      }
      @if (currentUser$ | async; as user) {
        @if (currentTab !== 'OUTLINE' || user.organization.allowOutlineDownload) {
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>download</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="exportDocument('pdf')">PDF</button>
            <button mat-menu-item (click)="exportDocument('docx')">DOCX</button>
          </mat-menu>
        }
      }
    </div>
  }
</div>
<div class="content">
  @if (currentTab === 'EDITOR') {
    <app-editor
      [call]="call"
      [canUserEdit]="canUserEdit"
      [canUserComment]="canUserComment"
      (isLocked)="isEditorLockedByOtherUser = $event"
      (openAgendaUpload)="openAgendaUpload.emit()"
      (openDocument)="openDocument.emit($event)"
      (openMeeting)="openMeeting.emit()"
    ></app-editor>
  } @else if (currentTab === 'OUTLINE') {
    <app-outline [call]="call"></app-outline>
  }
</div>
